import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getMatchDetails } from './../../helper/match'

import Intro from './Intro'
import Details from './Details'
import Standings from './Standings'

class PreMatch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      counter: 0,
      screen: 'intro',
      home: '',
      away: '',
      league: '',
      start: '',
      description: '',
      standings: [],
    }
  }

  componentDidMount() {
    getMatchDetails(this.props.match_id).then(data => {
      this.setState(
        {
          home: data.home.name,
          away: data.away.name,
          league: data.league,
          start: data.start,
          standings: data.standings,
          description: data.description
        },
        this._runCheck()
      )
    })
  }

  _runCheck() {
    const self = this
    this.setState(
      prevState => {
        return { counter: prevState.counter + 1 }
      },
      () => {
          this.setState(currentState => {
            if (currentState.screen === 'intro') {
              if (this.state.counter > 5) {
                return {
                  counter: 0,
                  screen: 'details',
                }
              }
            }
            if (currentState.screen === 'details') {
              if (this.state.counter > 5) {
                return {
                  counter: 0,
                  screen: 'standings',
                }
              }
            }
            if (currentState.screen === 'standings') {
              if (this.state.counter > 5) {
                return {
                  counter: 0,
                  screen: 'intro',
                }
              }
            }
          })
        setTimeout(() => self._runCheck(), 1000)
      }
    )
  }

  render() {
    if (this.state.screen === 'intro') {
      return (<Intro
            start={this.state.start}
            league={this.state.league}
            description={this.state.description}
            />)
    }
    if (this.state.screen === 'details') {
      return (<Details
            home={this.state.home}
            away={this.state.away}
          />)
    }
    return (<Standings
            standings={this.state.standings}
          />)
  }
}

const mapStateToProps = (state, ownProps) => ({
  match_id: state.match.match_id,
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PreMatch)
)
